var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_vm._l((5),function(star){return [(star <= _vm.quality)?_c('v-icon',{staticClass:"orange--text"},[_vm._v(" mdi-star ")]):_c('v-icon',[_vm._v(" mdi-star-outline ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }